import { get, post, put, del } from '../utils/request';
import { AdminAccount, PaginatedResponse } from '../types';

// 获取管理员列表
export async function getAdminList(params?: any): Promise<PaginatedResponse<AdminAccount>> {
  return get<PaginatedResponse<AdminAccount>>('/admin/admins', params);
}

// 校区管理员获取账号列表（仅上传专员）
export async function getCampusAdminList(params?: any): Promise<PaginatedResponse<AdminAccount>> {
  return get<PaginatedResponse<AdminAccount>>('/campus/admins', params);
}

// 创建校区负责人账号
export async function createCampusAdmin(account: string, campusId: string): Promise<{ id: string; account: string; initialPassword: string }> {
  return post('/admin/admins', { account, campusId });
}

// 创建上传专员账号
export async function createUploader(account: string, campusId: string): Promise<{ id: string; account: string; initialPassword: string }> {
  return post('/admin/admins/uploader', { account, campusId });
}

// 重置密码
export async function resetPassword(id: string): Promise<{ newPassword: string }> {
  return put(`/admin/admins/${id}/reset-password`, {});
}

// 更新账号状态
export async function updateAdminStatus(id: string, status: 'enabled' | 'disabled'): Promise<void> {
  return put(`/admin/admins/${id}/status`, { status });
}

// 删除账号
export async function deleteAdmin(id: string): Promise<void> {
  return del(`/admin/admins/${id}`);
}

// 校区负责人重置本校区上传专员密码
export async function campusResetPassword(id: string): Promise<{ newPassword: string }> {
  return put(`/campus/admins/${id}/reset-password`, {});
}

// 校区负责人删除本校区上传专员
export async function campusDeleteAdmin(id: string): Promise<void> {
  return del(`/campus/admins/${id}`);
}

// 获取账号详情
export async function getAdminDetail(id: string): Promise<AdminAccount> {
  return get<AdminAccount>(`/admin/admins/${id}`);
}
